import { render, staticRenderFns } from "./MealPlanReservation.vue?vue&type=template&id=019d0cff&scoped=true"
import script from "./MealPlanReservation.vue?vue&type=script&lang=js"
export * from "./MealPlanReservation.vue?vue&type=script&lang=js"
import style0 from "./MealPlanReservation.vue?vue&type=style&index=0&id=019d0cff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019d0cff",
  null
  
)

export default component.exports